var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"user-avatar",style:(_vm.avatarBackgroundStyles),attrs:{"title":_vm.user && _vm.user.name}},[_c('span',[_vm._v(_vm._s(_vm.abbreviation))]),(_vm.avatar && !_vm.isImageLoadFailed)?_c('img',{attrs:{"src":_vm.avatar,"alt":"user avatar"},on:{"error":_vm.handleImageLoadError}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }